import * as React from 'react';
import {View} from 'react-native';
import {Field} from 'redux-form';
import {BaseField, InputMaskTypes} from '../../../../shared/components/baseField';
import {Button} from '../../../../shared/components/button';
import {defaults} from '../../../../shared/constants/defaults';
import {useStyles} from '../../../../shared/hooks/styles';
import {LoginType, SendCodeResponsePayload} from '../../../../shared/models/api';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {CountDownTimer} from '../../../login/components/countDownTimer';
import {formatIdentificator} from '../../../login/formatters';

interface Props {
  onSubmit: (e?: any) => void;
  onRefresh: () => void;
  isConfirmButtonDisabled: boolean;
  sendCodeResponse: SendCodeResponsePayload;
}

export default ({onSubmit, onRefresh, isConfirmButtonDisabled, sendCodeResponse}: Props) => {
  const styles = useStyles(({mediaOnly}) => {
    return {
      container: {
        flexDirection: 'column',
        alignItems: 'center',
        ...mediaOnly(DeviceSize.desktop, {paddingTop: 0, paddingBottom: 0}, {paddingTop: 40, paddingBottom: 80}),
      },
      fieldContainer: {
        ...mediaOnly(DeviceSize.desktop, {width: '100%', alignItems: 'center'}, {width: 240, alignItems: 'stretch'}),
        flexDirection: 'column',
      },
      smsFieldContainer: {
        marginTop: 20,
        ...mediaOnly(DeviceSize.desktop, {marginBottom: 5}, {marginBottom: 26}),
      },
      button: {
        width: 240,
        ...mediaOnly(DeviceSize.desktop, {marginTop: 36}, {marginTop: 16}),
      },
      withOpacity: {
        opacity: 0.5,
      },
    };
  });

  return (
    <View style={styles.container}>
      <View style={[styles.fieldContainer, styles.withOpacity]}>
        <Field
          component={BaseField}
          label='Телефон'
          type='text'
          name='phone'
          mask={InputMaskTypes.tel}
          format={(v: any) => formatIdentificator(v, LoginType.PhoneNumber)}
          disabled
        />
      </View>
      <View style={[styles.fieldContainer, styles.smsFieldContainer]}>
        <Field
          component={BaseField}
          label='Код из SMS'
          type='digits'
          maxLength={defaults.smsCodeLength}
          name='smsCode'
          onSubmitEditing={onSubmit}
          autoFocus
        />
      </View>
      <CountDownTimer
        onRefresh={() => {
          onRefresh();
        }}
        until={sendCodeResponse?.resendCountdown || 300}
      />
      <Button
        id='profile-phone-confirmation-send'
        style={styles.button}
        disabled={isConfirmButtonDisabled}
        type='primary'
        text='Отправить'
        onPress={onSubmit}
      />
    </View>
  );
};
